<!--
  网上缴费
  Lovi 2020-2-18
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="gradient"
      :title="title[flag - 1]"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" @click="_linkFun('/record?flag=' + (flag + 7))">
        {{ $t("common.rechargeRecord") }}
      </span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <van-form @submit="topUpNow">
          <div class="column">
            <div class="title">
              <h3>{{ $t("onlinePay.fillPaymentInfo") }}</h3>
            </div>
            <div class="payInfo">
              <van-cell
                v-if="operatorList.length"
                :title="curOperator.name"
                @click="operatorFlag = true"
                is-link
              />
              <van-cell v-else :title="$t('common.selectOperator')" is-link />
              <div
                class="field-wrap"
                v-for="(item, index) in curParams"
                :key="index"
              >
                <!-- 金额 -->
                <van-field
                  v-if="item.is_money"
                  v-model="item.value"
                  type="number"
                  :name="item.key"
                  :formatter="_formatter"
                  :placeholder="item.label_cn"
                  clearable
                >
                  <span slot="right-icon">P</span>
                </van-field>
                <!-- 手机 -->
                <van-field
                  v-else-if="item.is_mobile"
                  v-model="item.value"
                  :name="item.key"
                  :placeholder="item.label_cn"
                  :error="error.phone ? true : false"
                  :maxlength="telMax"
                  :formatter="_phoneFormat"
                  @input="changeCellphone"
                  clearable
                />
                <!-- 日期 -->
                <van-field
                  v-else-if="item.is_date"
                  v-model="item.value"
                  :name="item.key"
                  :placeholder="item.label_cn"
                  readonly
                  @click="clickDate(item)"
                />
                <van-field
                  v-else
                  v-model="item.value"
                  :name="item.key"
                  :placeholder="item.label_cn"
                  clearable
                />
              </div>

              <p class="text">
                <span class="text-red">
                  <template v-if="deadlineFlag && overdueFlag">
                    {{ $t("onlinePay.overdue") }}
                    {{ curOperator.overdue_fee }}P
                    {{ $t("onlinePay.overdueFees") }}
                  </template>
                  <template v-else>
                    {{ $t("common.serviceCharge") }}
                    {{ curOperator.handling_fee }}P
                  </template>
                </span>
                <span class="text-orange" @click="sampleFlag = true">
                  {{ $t("common.help") }}<van-icon name="question-o" />
                </span>
              </p>
            </div>
          </div>

          <!-- 选择支付方式 -->
          <pay-list :money.sync="money" @getCurPay="getCurPay"  :flag="flag"/>

          <div class="button-wrap">
            <van-button block type="primary" native-type="submit">
              {{ $t("common.rechargeNow") }}
            </van-button>
            <p class="tips">
              {{ $t("common.payFeesTips") }}
            </p>
            <p class="tips text-red" >
             <!-- {{ $t("onlinePay." +
              "eWalletTips") }}-->
              {{note}}
            </p>
          </div>
        </van-form>
      </scroll>
    </div>

    <transition name="slide">
      <select-operator
        v-if="operatorFlag"
        :operatorFlag.sync="operatorFlag"
        :operatorList="operatorList"
        @getCurOperator="getCurOperator"
      />
    </transition>

    <transition name="slide">
      <sample
        v-if="sampleFlag"
        :sampleFlag.sync="sampleFlag"
        :samplePic="curOperator.billing_example"
        :imgList.sync="imgList"
        :imgId.sync="imgId"
      />
    </transition>

    <!-- 筛选日期 -->
    <van-popup v-model="selectDateFlag" get-container="body" position="bottom">
      <van-datetime-picker
        :title="$t('onlinePay.deadline')"
        type="date"
        v-model="selectDate"
        :formatter="formatter"
        @cancel="selectDateFlag = false"
        @confirm="confirmPicker"
      />
    </van-popup>

    <!-- 输入支付密码 -->
    <enter-paypsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="payment"
    />
  </div>
</template>

<script>
import { formatDate } from "@/commonJs/index.js";
import * as validate from "@/commonJs/validate.js";
import PayList from "@/components/payList";
import EnterPaypsd from "@/components/enterPayPsd";
import Sample from "./sample";
import SelectOperator from "./selectOperator";
export default {
  name: "onlinePay",
  components: {
    Sample,
    SelectOperator,
    PayList,
    EnterPaypsd
  },
  data() {
    return {
      // 1水费 2电费 3网费 4Grab充值 5银行 6贷款 7电子钱包 8保险 9房地产 10宿务航空 11政府 12支付网关
      // 业务类型，8水费 9电费 10网费 11Grab 12银行 13贷款 14电子钱包 15保险 16房地产 17宿务航空 18政府 19支付网关
      flag: 1,
      title: [
        this.$t("onlinePay.payWaterBills"),
        this.$t("onlinePay.payElectricityBills"),
        this.$t("onlinePay.payInternetBills"),
        this.$t("onlinePay.grabRecharge"),
        this.$t("onlinePay.bank"),
        this.$t("onlinePay.loan"),
        this.$t("onlinePay.eWallet"),
        this.$t("onlinePay.insurance"),
        this.$t("onlinePay.realEstate"),
        this.$t("onlinePay.cebuAir"),
        this.$t("onlinePay.government"),
        this.$t("onlinePay.paymentGateway")
      ],
      money: 0,
      operatorList: [], // 运营商列表
      curOperator: {}, // 当前运营商
      curParams: [], // 当前运营商参数
      operatorFlag: false, //选择运营商Flag

      sampleFlag: false, // 显示隐藏图片示例
      imgList: [], // 图片示例列表
      imgId: "", // 图片示例Id

      telMax: 13,
      error: {
        phone: false
      },

      selectDateFlag: false, //选择日期
      selectDate: new Date(), //选中日期默认当前日期
      deadlineFlag: false, // 手续费逾期费Flag
      overdueFlag: false, //逾期
      curPay: [], //当前支付数据
      note:"",

      payPsdFlag: false, //支付密码Flag
      payPsdData: {
        money: ""
      },

      min_money:0,
      max_money:0,

      curKey: "",
      values: {} // 参数值
    };
  },
  created() {
    let vm = this;
    vm.flag = Number(vm.$route.query.flag);
    vm.getOperatorList();
  },
  mounted() {},
  computed: {},
  methods: {
    getCurOperator(data) {
      // 当前运营商
      this.curOperator = data;
      this.curParams = this.processingParams(data.params);
      console.log("curOperator", this.curOperator);
      console.log("curParams", this.curParams);
    },
    processingParams(arr) {
      // 当前运营商参数处理
      if (!arr.length) {
        return [];
      }
      let list = arr.map(item => {
        this.$set(item, "value", "");
        return item;
      });
      return list;
    },
    changeCellphone(value) {
      // 校验手机号
      console.log("phone", value);
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        this.telMax1 = 13;
      } else {
        //否则输入框最多输入12位
        this.telMax1 = 12;
      }
      let phone = value.replace(/\s/g, "");
      this.error.phone = validate.validateMobile(phone);
    },
    formatter(type, val) {
      // 自定义日期文案
      console.log(type, val);
      if (type === "year") {
        return val + this.$t("common.year");
      } else if (type === "month") {
        return val + this.$t("common.month");
      } else if (type === "day") {
        return val + this.$t("common.days");
      }
      return val;
    },
    clickDate(data) {
      // 点击日期
      console.log("clickDate", data);
      this.curKey = data.key;
      this.selectDateFlag = true;
    },
    confirmPicker(date) {
      // 确认截止时间
      let vm = this;
      let newDate = formatDate(date, "yyyy-MM-dd");
      vm.selectDate = date;
      vm.selectDateFlag = false;
      for (let i of vm.curParams) {
        if (i.key == vm.curKey) {
          i.value = formatDate(date, "yyyy-MM-dd");
          if (i.is_deadline) {
            let now = formatDate(new Date(), "yyyy-MM-dd");
            if (newDate < now) {
              // 选择日期小于当前日期为逾期
              vm.overdueFlag = true;
            } else {
              vm.overdueFlag = false;
            }
          }
        }
      }
    },
    getCurPay(data) {
      //获取当前支付信息
      this.curPay = data;
      console.log("curPay", this.curPay);
    },
    topUpNow(values) {
      //立即充值
      let vm = this;
      // 校验必填
      for (let key of vm.curParams) {
        if (key.value == "") {
          vm.$toast(vm.$t("onlinePay.pleaseFillIn") + key.label_cn);
          return;
        }
      }
      // 处理手机号码格式
      for (let key in values) {
        if (key == "mobile_number") {
          let mobile = "0" + Number(values[key].replace(/\s/g, ""));
          vm.$set(values, key, mobile);
        }
      }
      vm.values = values;
      if (vm.curPay.type == 3) {
        // 余额充值
        vm.payPsdData.money = vm.money.toFixed(2);
        vm.payPsdFlag = true;
      }
      if (vm.curPay.type == 5||vm.curPay.type == 1||vm.curPay.type == 2||vm.curPay.type == 10) {
        // h5微信支付
        vm.payment();
      }
    },
    payment(data) {

      // 微信支付宝
      let vm = this;
      if(parseFloat(vm.min_money)>0&&parseFloat(vm.max_money)>0&&(parseFloat(vm.values.BillAmount)<parseFloat(vm.min_money)||parseFloat(vm.values.BillAmount)>parseFloat(vm.max_money)))
      {
        vm.$toast("输入金额应该在"+vm.min_money+"---"+vm.max_money+"PHP之间");
        return false;
      }
      let params = {};
      params.operator_id = vm.curOperator.operator_id;
      params.params = JSON.stringify(vm.values);
      params.type = vm.flag + 7;
      params.payment_id = vm.curPay.payment_id;
      params.pay_password = data || "";
      params.images = vm.imgId;
      //if()
      vm.$post("/app/recharge/payBill", params, { loading: true }).then(res => {
        console.log("payment", res);
        vm.imgList = [];
        vm.imgId = "";
        let routeData = res;
        if (vm.curPay.type == 3) {
          // 余额充值
          routeData.button = true;
          vm.$router.push({
            path: "/detail",
            name: "detail",
            query: { flag: vm.flag + 7, order_id: res.order_id },
            params: routeData
          });
        }

        if (vm.curPay.type == 5) {
          // 微信扫码支付
          routeData.money = vm.money.toFixed(2) + "P";
          // 线上支付
          vm.$router.push({
            path: "/payCode",
            name: "payCode",
            query: { flag: vm.flag + 7, payType: vm.curPay.type },
            params: routeData
          });
        }

        if (vm.curPay.type == 2||vm.curPay.type == 10) {
          //支付宝app付
          /* eslint-disable */

          if(vm.curPay.type == 10)
          {
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: vm.flag + 7,
                order_id: res.order_id
              },
              params: routeData
            });

          }
          else {
            jsBridge.aliPay({
              orderString: res.return_charge.query
            }, function(succ, text) {
              if (succ) {
                vm.$toast("支付成功");
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: vm.flag + 7,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {
                vm.$toast("支付失败或取消了支付");
              }
            });
          }
        }
        if (vm.curPay.type == 1) {
          //微信app付
          /* eslint-disable */

          if (vm.enter == "wechat") {
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: vm.flag + 7,
                order_id: res.order_id
              },
              params: routeData
            });
          }
          else {
            jsBridge.wxPay({
              appid: res.return_charge.appid,
              partnerid: res.return_charge.partnerid,
              prepayid: res.return_charge.prepayid,
              package: res.return_charge.package,
              noncestr: res.return_charge.noncestr,
              timestamp: res.return_charge.timestamp,
              sign: res.return_charge.sign
            }, function(succ, text) {
              if (succ) {
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: vm.flag + 7,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {

              }
            });
          }
        }
      });
    },
    getOperatorList() {
      // 获取运营商信息
      let vm = this;
      vm.$post(
        "/app/recharge/getOperatorList",
        { type: vm.flag },
        { loading: true }
      ).then(res => {
        console.log("getOperatorList", res);
        vm.operatorList = res.list;
        vm.curOperator = res.list[0];
        vm.curParams = vm.processingParams(res.list[0].params);
        console.log("curOperator", vm.curOperator);
        console.log("curParams", vm.curParams);
      });
    }
  },
  watch: {
    curParams: {
      // 当前运营商
      handler: function(arr) {
        let vm = this;
        let money = 0;
        if (!arr.length) {
          return false;
        }
        for (let key of arr) {
          if (key.is_pay_amount) {
            money = key.value;
          }
          if (key.is_deadline) {
            // 如果有截止日期
            if (key.value == "") {
              vm.deadlineFlag = false;
            } else {
              vm.deadlineFlag = true;
            }
          }
        }
        if (vm.overdueFlag) {
          // 金额加逾期费
          vm.money = Number(money) + Number(vm.curOperator.overdue_fee);
        } else {
          // 金额加手续费
          vm.money = Number(money) + Number(vm.curOperator.handling_fee);
        }
        let curLanguage = localStorage.getItem("language");
        console.log("dsadasd"+curLanguage);
        if (curLanguage == "zh")
        {
          vm.note = vm.curOperator.note_zh;
        }
        else
        {
          vm.note = vm.curOperator.note;
        }

        vm.min_money = vm.curOperator.min_money;
        vm.max_money = vm.curOperator.max_money;

        console.log("deadlineFlag", vm.deadlineFlag);
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}

.button-wrap .text-red {
  color: #ff2b2b;
}

.payInfo {
  padding: 0 10px 10px;
  .text {
    padding-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      /deep/.van-icon {
        margin-left: 2px;
      }
    }
  }
  .field-wrap {
    margin-top: 10px;
  }
  /deep/.van-cell {
    padding: 10px;
    border: 1.1px solid #b6b6b6;
    border-radius: 5px;
    &:first-child {
      margin-top: 0;
    }
    .text-orange,
    .text-gray {
      font-size: 12px;
    }
    .text-orange {
      text-decoration: underline;
    }
    /deep/.van-cell__title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    /deep/.van-field__right-icon {
      line-height: 1;
    }
  }
  .van-field-phone {
    /deep/.van-field__body {
      position: relative;
      .van-field__control {
        z-index: 1;
        position: relative;
      }
      .van-field__right-icon {
        position: absolute;
        right: 0;
      }
    }
  }
}
</style>
